import React, { HTMLProps, useState } from 'react'
import { Waypoint } from 'react-waypoint'
import { twMerge } from 'tailwind-merge'

type Props = HTMLProps<HTMLDivElement> & Waypoint.WaypointProps

interface FadeInProps extends Props {
  children: JSX.Element
  appearFromBottom?: boolean
}

const FadeIn = ({
    children,
    className,
    appearFromBottom = false,
    onEnter,
    onLeave,
    scrollableAncestor,
    ...props
}: FadeInProps) => {
    const [visible, setVisible] = useState(false)
    return (
        <Waypoint
            onEnter={(args) => {
                setVisible(true)
        onEnter?.(args)
            }}
            onLeave={(args) => onLeave?.(args)}
            scrollableAncestor={scrollableAncestor}
        >
            <div
                style={{
                    transform: visible || !appearFromBottom ? 'translateY(0)' : 'translateY(100px)',
                    opacity: visible ? 1 : 0,
                }}
                className={twMerge('transition delay-500 duration-1000 ease-out', className)}
                {...props}
            >
                {children}
            </div>
        </Waypoint>
    )
}

export default FadeIn
